<template>
  <Dialog
    :visible="showWelcomeThemeModal"
    modal
    :closable="false"
    :draggable="false"
    :dismissable-mask="false"
    class="theme-welcome-dialog"
    :style="{ width: 'min(38rem, 96vw)' }"
    :breakpoints="{ '640px': '94vw' }"
    :header="$t('appearance.welcomeTitle')"
    @update:visible="onUpdateVisible"
  >
    <p class="theme-welcome-lead">{{ $t('appearance.welcomeLead') }}</p>
    <div class="theme-welcome-grid" role="group" :aria-label="$t('appearance.welcomeGroupAria')">
      <button type="button" class="theme-welcome-card theme-welcome-card--dark" @click="choose('dark')">
        <span class="theme-welcome-card__preview theme-welcome-card__preview--dark" aria-hidden="true" />
        <span class="theme-welcome-card__label">{{ $t('appearance.optionDark') }}</span>
        <span class="theme-welcome-card__hint">{{ $t('appearance.optionDarkHint') }}</span>
      </button>
      <button type="button" class="theme-welcome-card theme-welcome-card--light" @click="choose('light')">
        <span class="theme-welcome-card__preview theme-welcome-card__preview--light" aria-hidden="true" />
        <span class="theme-welcome-card__label">{{ $t('appearance.optionLight') }}</span>
        <span class="theme-welcome-card__hint">{{ $t('appearance.optionLightHint') }}</span>
      </button>
    </div>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import { useAppearanceStore } from '@/store/appearance';

export default {
  name: 'ThemePreferenceModal',
  components: { Dialog },
  computed: {
    appearance() {
      return useAppearanceStore();
    },
    showWelcomeThemeModal() {
      return this.appearance.showWelcomeThemeModal;
    },
  },
  methods: {
    choose(theme) {
      this.appearance.completeWelcomeChoice(theme);
    },
    onUpdateVisible(v) {
      if (v) return;
      try {
        if (typeof localStorage !== 'undefined' && localStorage.getItem('kosexa-appearance-prompted') === '1') {
          return;
        }
      } catch {
        /* ignore */
      }
      this.appearance.showWelcomeThemeModal = true;
    },
  },
};
</script>

<style scoped>
.theme-welcome-lead {
  margin: 0 0 1.5rem;
  line-height: 1.55;
  color: var(--text-color);
  font-size: clamp(1.05rem, 2.8vw, 1.25rem);
  font-weight: 500;
}

.theme-welcome-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

@media (max-width: 520px) {
  .theme-welcome-grid {
    grid-template-columns: 1fr;
  }
}

.theme-welcome-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  padding: 1.1rem 1.15rem 1.2rem;
  border-radius: 12px;
  border: 1px solid var(--border-accent);
  background: var(--surface-100);
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.15s ease;
  color: var(--text-color);
}

.theme-welcome-card:hover {
  border-color: var(--primary-color);
  box-shadow: 0 4px 20px var(--shadow-color);
  transform: translateY(-1px);
}

.theme-welcome-card:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

.theme-welcome-card__preview {
  height: 4.25rem;
  border-radius: 8px;
  margin-bottom: 0.85rem;
  border: 1px solid var(--border-accent);
}

.theme-welcome-card__preview--dark {
  background: linear-gradient(135deg, #0f1411 0%, #070a08 55%, #1e3229 100%);
}

.theme-welcome-card__preview--light {
  background: linear-gradient(135deg, #faf8f4 0%, #f0ebe3 45%, #e8efe9 100%);
}

.theme-welcome-card__label {
  font-weight: 700;
  font-size: clamp(1.15rem, 3vw, 1.35rem);
  margin-bottom: 0.35rem;
  letter-spacing: 0.01em;
}

.theme-welcome-card__hint {
  font-size: clamp(0.95rem, 2.2vw, 1.05rem);
  color: var(--text-secondary);
  line-height: 1.45;
}
</style>

<!--
  PrimeVue monta el diálogo en body: hace falta CSS sin scope para cabecera / caja.
-->
<style>
.p-dialog.theme-welcome-dialog .p-dialog-header {
  font-size: clamp(1.2rem, 3.2vw, 1.55rem);
  font-weight: 800;
  line-height: 1.3;
  padding: 1.35rem 1.5rem 1rem;
  border-radius: 0;
}

.p-dialog.theme-welcome-dialog .p-dialog-content {
  padding: 0.25rem 1.5rem 1.6rem;
  font-size: 1.0625rem;
}

.p-dialog.theme-welcome-dialog .p-dialog-header .p-dialog-title {
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}
</style>
